import { productGraphReducer as productGraph } from './reducers';
import * as sagas from './sagas';

const productGraphState = { reducers: { productGraph }, sagas };

export default productGraphState;
